import { ChangeDetectionStrategy, Component, computed, effect, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { SearchSvgIconComponent } from '../svg-icons/search-svg-icon/search-svg-icon.component';
import { SearchBarValue } from '@core/services/search-bar-value/search-bar-value';
import { MenuActions } from '../../states/menu_actions';
import { CloseSvgIconComponent } from '@components/svg-icons/close-svg-icon/close-svg-icon.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-search-bar',
  imports: [FormsModule, ReactiveFormsModule, SearchSvgIconComponent, CloseSvgIconComponent, TranslocoPipe],
  templateUrl: './ln-search-bar.component.html',
  styleUrl: './ln-search-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnSearchBarComponent implements OnInit, OnDestroy {
  readonly TAG = 'LnSearchBarComponent';
  searchBarValue = inject(SearchBarValue);
  menuActions: MenuActions = inject(MenuActions);
  searchControl = new FormControl();
  private searchControlSubscription!: Subscription;
  protected showSearchIcon: Signal<boolean> = computed(() => this.searchBarValue.searchBarValue() === '');
  ngOnInit(): void {
    this.SearchControlSetup();
  }

  constructor() {
    effect(() => {
      const searchBarValue = this.searchBarValue.searchBarValue();
      this.updateSearchBarValue(searchBarValue);
    });
  }
  updateSearchBarValue(searchBarValue: string): void {
    this.searchControl.setValue(searchBarValue);
    // this.cdr.detectChanges();
  }

  SearchControlSetup() {
    this.searchControlSubscription = this.searchControl.valueChanges
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe(value => {
        if (value !== null) {
          this.searchBarValue.setSearchBarValue(value);
        }
      });
  }

  navigateToSearchPage(): void {
    if (this.searchControl.value) {
      this.menuActions.navigateToSearchPage(this.searchControl.value);
    }
  }

  buttonSearchClose() {
    this.searchBarValue.setSearchBarValue('');
  }

  ngOnDestroy(): void {
    this.searchControlSubscription.unsubscribe();
  }
}
